import type { SelectedAddressBookItems } from "~/features/quote/context/quote-address-context.tsx";
import type { AddressBookItemSummary } from "~/shared/schemas/address-book-schema.ts";

export const ADDRESS_FIELD_MAX_LENGTH = 50;

function isOverLimit(value: string | null | undefined): boolean {
	return (value?.length ?? 0) > ADDRESS_FIELD_MAX_LENGTH;
}

function isStopOverLimit(
	stop: AddressBookItemSummary | null,
	stopType: number,
): boolean {
	const detail = stop?.details.find((d) => d.stopType === stopType);

	return (
		isOverLimit(stop?.companyName) ||
		isOverLimit(stop?.address1) ||
		isOverLimit(stop?.address2) ||
		isOverLimit(detail?.contactName)
	);
}

/**
 * True when any pickup/delivery text field the API caps at 50 characters is over
 * the limit. Used to disable the Tender button so the blocked submission gives
 * feedback at the button, matching the inline "Cannot exceed character limit."
 * errors on the fields themselves.
 */
export function hasAddressFieldOverLimit(
	selectedAddressBookItems: SelectedAddressBookItems,
): boolean {
	return (
		isStopOverLimit(selectedAddressBookItems.pickup, 1) ||
		isStopOverLimit(selectedAddressBookItems.delivery, 2)
	);
}
